import { useState } from "react";
import { Upload, FileDown, FileSpreadsheet } from "lucide-react";
import { MockBanner } from "@/components/ui/MockBanner";
import { exportPdf, exportExcel } from "@/lib/exporters";

interface HeaderProps {
  onOpenImport: () => void;
}

export function Header({ onOpenImport }: HeaderProps) {
  const [busy, setBusy] = useState(false);

  async function onExcel() {
    setBusy(true);
    try {
      await exportExcel();
    } finally {
      setBusy(false);
    }
  }

  return (
    <header className="z-20 border-b border-slate-200 bg-white/85 backdrop-blur lg:sticky lg:top-0 print:static">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-3 px-4 py-3 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:gap-6 lg:px-8">
        <div className="min-w-0">
          <h1 className="text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
            Raportare profitabilitate &amp; producție
          </h1>
          <p className="mt-0.5 text-sm leading-snug text-slate-500">
            Cost real /oră, media mobilă, profitabilitate client/produs, încărcare mașini, export vs. intern.
          </p>
        </div>
        <div className="flex w-full min-w-0 flex-col gap-2 sm:flex-row sm:items-center lg:w-auto lg:shrink-0 print:hidden">
          <div className="min-w-0 lg:max-w-xs">
            <MockBanner />
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <button
              onClick={exportPdf}
              className="inline-flex shrink-0 items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-50"
              title="Export PDF (print) al dashboard-ului filtrat"
            >
              <FileDown className="h-4 w-4" />
              PDF
            </button>
            <button
              onClick={onExcel}
              disabled={busy}
              className="inline-flex shrink-0 items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-50 disabled:cursor-wait disabled:opacity-60"
              title="Export Excel (.xlsx) al datelor filtrate"
            >
              <FileSpreadsheet className="h-4 w-4" />
              {busy ? "…" : "Excel"}
            </button>
            <button
              onClick={onOpenImport}
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg bg-brand-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-700"
            >
              <Upload className="h-4 w-4" />
              Importă
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
